import { RIGHT_ARROW } from "../lib/assets";

export const FEATURE_TWO_LIST = [
  {
    id: 1,
    icon: "flaticon-profit",
    title: "Growing Business",
    subtitle: "Finance helps you to convert into a strategic asset get.",
  },
  {
    id: 2,
    icon: "flaticon-investment",
    title: "Finance Investment",
    subtitle: "Finance helps you to convert into a strategic asset get.",
  },
  {
    id: 3,
    icon: "flaticon-taxes",
    title: "Tax Advisory",
    subtitle: "Finance helps you to convert into a strategic asset get.",
  },
];

export const FEATURE_THREE_LIST = [
  {
    id: 1,
    title: "Technology Solutions by Ajinkya Technologies ",
    subtitle:
      "Delivering innovative software, automation, and digital transformation services to empower businesses with technology that accelerates growth and efficiency.",
    // href: "/services-details",
    // src: RIGHT_ARROW,
  },
  {
    id: 2,
    title: "Land Development & Construction Infrastructure",
    subtitle:
      "Comprehensive land development and construction services, turning visions into reality with sustainable and scalable infrastructure projects.",
    // href: "/services-details",
    // src: RIGHT_ARROW,
  },
  {
    id: 3,
    title: "Agriculture & Dairy Production",
    subtitle:
      "Specialized in cultivating high-quality vegetables, fruits, farm produce, and dairy products using sustainable farming practices to meet growing consumer demands.",
    // href: "/services-details",
    // src: RIGHT_ARROW,
  },
  {
    id: 4,
    title: "Renewable Energy Production & Trade",
    subtitle:
      "Pioneering green energy production and trading, harnessing solar, wind, and other renewable sources for a cleaner, sustainable energy future.",
    // href: "/services-details",
    // src: RIGHT_ARROW,
  },
];

export const FEATURE_FOUR_LIST = [
  {
    id: 1,
    icon: "flaticon-life-insurance",
    title: "More coverage",
    subtitle: "Finance helps you to convert into a strategic asset get.",
  },
  {
    id: 2,
    icon: "flaticon-handshake",
    title: "Less hassle",
    subtitle: "Finance helps you to convert into a strategic asset get.",
  },
  {
    id: 3,
    icon: "flaticon-money",
    title: "Faster benefits",
    subtitle: "Finance helps you to convert into a strategic asset get.",
  },
];

export const FEATURE_ONE_LIST = [
  {
    id: 1,
    icon: "flaticon-puzzle-piece",
    title: "Quality Services",
    subtitle: "Eiusmod Temporincididunt Ut Labore Magna Aliqua Quisery.",
  },
  {
    id: 2,
    icon: "flaticon-inspiration",
    title: "Innovation Ideas",
    subtitle: "Eiusmod Temporincididunt Ut Labore Magna Aliqua Quisery.",
  },
  {
    id: 3,
    icon: "flaticon-profit",
    title: "Business Growth",
    subtitle: "Eiusmod Temporincididunt Ut Labore Magna Aliqua Quisery.",
  },
];
